import React from 'react';
import { minStartLocal } from './useReportsMode';

/**
 * Schedule step body — Create Schedule API fields:
 * name, frequency, start time (now + 1h minimum), timezone, active, recipients.
 */

export const FREQUENCIES = [
  { value: 'once', label: 'Once' },
  { value: 'daily', label: 'Daily' },
  { value: 'weekly', label: 'Weekly' },
  { value: 'monthly', label: 'Monthly' },
  { value: 'yearly', label: 'Yearly' },
];

const ScheduleStep = ({ schedule, updateSchedule, submitting, error }) => {
  if (!schedule) return null;
  const min = minStartLocal();
  const startTooSoon = schedule.startAt && schedule.startAt < min;

  return (
    <div className="reports-schedule-step">
      <div className="reports-field">
        <label className="reports-field-label" htmlFor="reports-schedule-name">Name</label>
        <input
          id="reports-schedule-name"
          type="text"
          className="reports-input"
          value={schedule.name}
          onChange={(e) => updateSchedule({ name: e.target.value })}
          disabled={submitting}
        />
      </div>

      <div className="reports-field">
        <div className="reports-field-label">Frequency</div>
        <div className="reports-cadence-grid">
          {FREQUENCIES.map((f) => (
            <button
              type="button"
              key={f.value}
              className={`reports-cadence-option${schedule.frequency === f.value ? ' reports-cadence-option--selected' : ''}`}
              aria-pressed={schedule.frequency === f.value}
              onClick={() => updateSchedule({ frequency: f.value })}
              disabled={submitting}
            >
              {f.label}
            </button>
          ))}
        </div>
      </div>

      <div className="reports-field">
        <label className="reports-field-label" htmlFor="reports-schedule-start">Start time</label>
        <input
          id="reports-schedule-start"
          type="datetime-local"
          className="reports-input"
          min={min}
          value={schedule.startAt}
          onChange={(e) => updateSchedule({ startAt: e.target.value })}
          disabled={submitting}
        />
        {startTooSoon && (
          <span className="reports-field-error">
            Start time must be at least one hour from now.
          </span>
        )}
      </div>

      <div className="reports-field reports-field--row">
        <label className="reports-toggle">
          <input
            type="checkbox"
            checked={schedule.isActive}
            onChange={(e) => updateSchedule({ isActive: e.target.checked })}
            disabled={submitting}
          />
          <span>Active</span>
        </label>
        <span className="reports-schedule-tz">Timezone: <strong>{schedule.timezone}</strong></span>
      </div>

      <div className="reports-field">
        <label className="reports-field-label" htmlFor="reports-schedule-to">
          Recipients (To)
        </label>
        <input
          id="reports-schedule-to"
          type="text"
          className="reports-input"
          placeholder="email@example.com, another@example.com"
          value={schedule.toEmail}
          onChange={(e) => updateSchedule({ toEmail: e.target.value })}
          disabled={submitting}
        />
      </div>

      <div className="reports-field">
        <label className="reports-field-label" htmlFor="reports-schedule-cc">CC</label>
        <input
          id="reports-schedule-cc"
          type="text"
          className="reports-input"
          placeholder="optional, comma-separated"
          value={schedule.ccEmail}
          onChange={(e) => updateSchedule({ ccEmail: e.target.value })}
          disabled={submitting}
        />
      </div>

      <div className="reports-field">
        <label className="reports-field-label" htmlFor="reports-schedule-bcc">BCC</label>
        <input
          id="reports-schedule-bcc"
          type="text"
          className="reports-input"
          placeholder="optional, comma-separated"
          value={schedule.bccEmail}
          onChange={(e) => updateSchedule({ bccEmail: e.target.value })}
          disabled={submitting}
        />
      </div>

      {error && <div className="reports-field-error">{error}</div>}
    </div>
  );
};

export default ScheduleStep;
